import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-country-lookup',
  templateUrl: './micro-country-lookup.component.html'
})
export class MicroCountryLookupComponent  {

  @Input()
  countryId:any;
}
